import { useState } from 'react';

import { useConnectStore } from '../../../../../../store/models';
import { getPlanTier } from '../downgradePlanDialog/downgradeCopy';

// One extra-transactions pack always represents 1000 transactions — baked into
// the add-on's name/handle on the backend (e.g. "...-extra-transactions-1000"),
// which has no separate pack-size field.
const PACK_SIZE = 1000;

/*
 * Drives the Pick step (quantity of transaction packs) and shapes the plan/
 * add-on data the shared CheckoutDrawer needs to preview and charge for it.
 * Payment/tokenization/3D-Secure are all owned by CheckoutDrawer itself.
 */
function usePurchaseTransactionsDialogState () {
    const connectStore = useConnectStore();

    const [packs, setPacksRaw] = useState(1);

    function setPacks (value) {
        const next = parseInt(value, 10);
        setPacksRaw(Number.isNaN(next) || next < 1 ? 1 : next);
    }

    function incPacks () {
        setPacksRaw((p) => p + 1);
    }

    function decPacks () {
        setPacksRaw((p) => Math.max(1, p - 1));
    }

    const currentPlan = connectStore.currentPlan;

    // Prefer an exact code match; fall back to tier matching (same convention as
    // upgradePlanDialog/downgradeCopy's getPlanTier) only if code is missing.
    const currentTier = currentPlan && getPlanTier(currentPlan.name);
    const planCatalogEntry = currentPlan && (connectStore.availablePlans || []).find((p) => (
        currentPlan.code ? p.code === currentPlan.code : (currentTier && getPlanTier(p.name) === currentTier)
    ));
    const transactionPackAddOn = planCatalogEntry &&
        (planCatalogEntry.addOns || []).find((a) => a.handle.includes('extra-transactions'));

    const packSize = PACK_SIZE;
    const pricePerPack = transactionPackAddOn ? Number(transactionPackAddOn.price) : 0;
    const quantity = packs * packSize;
    const amount = packs * pricePerPack;

    const plan = (currentPlan && transactionPackAddOn) ? {
        name: currentPlan.name,
        code: planCatalogEntry.code,
        chargifyCode: planCatalogEntry.code,
        price: { monthly: Number(currentPlan.price), currency: currentPlan.currency },
        addOns: [transactionPackAddOn],
    } : null;
    const addOnValues = transactionPackAddOn ? { [transactionPackAddOn.id]: packs } : {};

    return {
        packs,
        setPacks,
        incPacks,
        decPacks,
        packSize,
        pricePerPack,
        quantity,
        amount,
        plan,
        addOnValues,
        transactionPackAddOn,
    };
}

export default usePurchaseTransactionsDialogState;
